<kendo-gridlayout class="agreement-return" [gap]="5">
  <ng-content />
</kendo-gridlayout>
